/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InscriptionDeleteSansSuiteDto
 */
export interface InscriptionDeleteSansSuiteDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof InscriptionDeleteSansSuiteDto
     */
    idsinscription?: Array<number> | null;
}

/**
 * Check if a given object implements the InscriptionDeleteSansSuiteDto interface.
 */
export function instanceOfInscriptionDeleteSansSuiteDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InscriptionDeleteSansSuiteDtoFromJSON(json: any): InscriptionDeleteSansSuiteDto {
    return InscriptionDeleteSansSuiteDtoFromJSONTyped(json, false);
}

export function InscriptionDeleteSansSuiteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InscriptionDeleteSansSuiteDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idsinscription': !exists(json, 'idsinscription') ? undefined : json['idsinscription'],
    };
}

export function InscriptionDeleteSansSuiteDtoToJSON(value?: InscriptionDeleteSansSuiteDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idsinscription': value.idsinscription,
    };
}

